module.exports = __webpack_public_path__ + "img/directing.7b5b6798.jpg";